import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export interface IListable {
  first: boolean;
  last: boolean;
  shouldRenderDefaultBackground?: boolean;
}

export const Section = styled.section<IListable>`
  display: block;
  background-color: ${p =>
    p.shouldRenderDefaultBackground ? p.theme.token('background-default') : 'transparent'};
  padding: ${primitive.$spacing4} 0 ${primitive.$spacing4};
  padding-top: ${({ first }) => (first ? primitive.$spacing7 : primitive.$spacing4)};
  padding-bottom: ${({ last }) => (last ? primitive.$spacing7 : primitive.$spacing4)};

  ${Styles.desktop`
    padding-top: ${({ first }: IListable) => (first ? primitive.$spacing7 : primitive.$spacing4)};
    padding-bottom: ${({ last }: IListable) => (last ? primitive.$spacing7 : primitive.$spacing4)};
  `}
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Spacer = (_: { $hasBottomServiceMode: boolean }) => null;
